export default {
    handOpenState(state, bool){
        state.isOpen = bool;
    }
};